import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

export default function TermsConsent({ accepted, onChange }) {
  return (
    <div className="space-y-3 p-4 bg-slate-50 rounded-lg border border-slate-200" data-testid="terms-consent">
      <div className="flex items-center gap-2">
        <ShieldCheck className="h-5 w-5 text-[#0F2A44]" />
        <h3 className="font-manrope font-semibold text-[#0F2A44]">Terms & Conditions</h3>
      </div>
      <div className="text-xs text-[#4B5563] space-y-2 max-h-40 overflow-y-auto p-3 bg-white rounded border border-slate-100">
        <p>By submitting this registration form, I acknowledge and agree to the following:</p>
        <p><strong>1. Accuracy of Information:</strong> I certify that all information provided in this form is true, accurate, and complete to the best of my knowledge. I understand that providing false or misleading information may result in the removal of my listing and potential legal action.</p>
        <p><strong>2. Liability Disclaimer:</strong> I acknowledge that Afyagram is a healthcare provider discovery platform and does not provide medical advice, diagnosis, or treatment. Afyagram shall not be held liable for any clinical outcomes, disputes, malpractice claims, or any other litigations arising from services rendered by listed providers.</p>
        <p><strong>3. Indemnification:</strong> I agree to indemnify and hold harmless Afyagram, its officers, directors, employees, and agents from and against any claims, damages, losses, or expenses arising from my listing, services, or any inaccurate information provided.</p>
        <p><strong>4. Consent to Verification:</strong> I consent to Afyagram verifying my professional credentials, including but not limited to KMPDC registration status, and displaying verification status on my public profile.</p>
        <p><strong>5. Data Usage:</strong> I consent to Afyagram collecting, storing, and displaying the information provided for the purpose of connecting patients with healthcare providers. My data will be handled in accordance with Kenya's Data Protection Act (2019).</p>
        <p><strong>6. Platform Rights:</strong> Afyagram reserves the right to modify, suspend, or remove any listing at its discretion, including for quality assurance, compliance, or any breach of these terms.</p>
      </div>
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={accepted}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-1 h-4 w-4 rounded border-slate-300 text-[#2DD4BF] focus:ring-[#2DD4BF]"
          data-testid="terms-checkbox"
        />
        <span className="text-sm text-[#4B5563]">
          I have read and agree to the{' '}
          <Link to="/terms" target="_blank" className="text-[#4A90E2] hover:underline">Terms & Conditions</Link>
          {' '}and consent to the liability disclaimer above.
        </span>
      </label>
    </div>
  );
}
